<template lang="pug">
div
  label {{ label }}
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  .flex
    label(class="inputLabel") Minutes
    BriqInput(
      v-model="minutes"
      v-bind="$attrs"
      class="input inputMinutes"
      type="number"
      :required="false"
      )
    label(class="inputLabel") Hours
    BriqInput(
      v-model="hours"
      v-bind="$attrs"
      id="hours"
      class="input"
      type="number"
      :required="false"
      )
    label(class="inputLabel") Days
    BriqInput(
      v-model="days"
      type="number"
      id="days"
      class="input"
      v-bind="$attrs"
      :required="false"
      )
    label(class="inputLabel" v-show="monthsVisible") Months
    BriqInput(
      v-show="monthsVisible"
      v-model="months"
      type="number"
      id="months"
      class="input"
      v-bind="$attrs"
      :required="false"
      )
    label(class="inputLabel" v-show="yearsVisible")  Years
    BriqInput(
      v-show="yearsVisible"
      v-model="years"
      type="number"
      id="years"
      class="input"
      v-bind="$attrs"
      :required="false"
      )
  .form-help-text(v-if="suggestedValue") {{ suggestedValue }}
  .validation-message(v-if="error") {{ error }}
</template>

<script>
import parse from '@tehshrike/duration-iso-8601'

export default {
  name: 'BriqIsoDurationInput',
  inheritAttrs: false,
  data() {
    return {
      innerValue: null,
      years: null,
      months: null,
      days: null,
      hours: null,
      minutes: null,
    }
  },
  props: {
    label: String,
    hideOptionalMarker: { type: Boolean, default: false },
    help: String,
    suggestedValue: String,
    error: String,
    value: [String, Number],
    monthsVisible: { type: Boolean, required: false, default: false },
    yearsVisible: { type: Boolean, required: false, default: false },
  },
  computed: {
    changeData() {
      const { minutes, hours, days, months, years } = this
      return {
        minutes,
        hours,
        days,
        months,
        years,
      }
    },
  },
  methods: {
    parseInnerValue() {
      const parsedInnerValue =
        typeof this.innerValue !== 'undefined' && this.innerValue !== null
          ? parse(this.innerValue)
          : {}

      this.years = parsedInnerValue?.year > 0 ? parsedInnerValue.year : null
      this.months = parsedInnerValue?.month > 0 ? parsedInnerValue.month : null
      this.days = parsedInnerValue?.day > 0 ? parsedInnerValue.day : null
      this.hours = parsedInnerValue?.hour > 0 ? parsedInnerValue.hour : null
      this.minutes =
        parsedInnerValue?.minute > 0 || parsedInnerValue?.minute === 0
          ? parsedInnerValue.minute
          : null
      // 0 minutes will be returned as PT0S from the API, so we need to account for that (when no minutes are set)
      if (parsedInnerValue?.second === 0 && this.minutes === null) this.minutes = 0
    },
    convertDataToIsoDuration() {
      let innerValueArr = []

      if (
        this.years > 0 ||
        this.months > 0 ||
        this.days > 0 ||
        this.hours > 0 ||
        this.minutes !== null
      ) {
        innerValueArr.push('P')
      }

      this.years > 0 ? innerValueArr.push(`${this.years}Y`) : ''
      this.months > 0 ? innerValueArr.push(`${this.months}M`) : ''
      this.days > 0 ? innerValueArr.push(`${this.days}D`) : ''

      if (this.hours > 0 || this.minutes !== null) {
        innerValueArr.push('T')
      }

      this.hours > 0 ? innerValueArr.push(`${this.hours}H`) : ''
      this.minutes !== null ? innerValueArr.push(`${this.minutes}M`) : ''

      this.innerValue = innerValueArr.join('')

      this.$emit('input', this.innerValue)
    },
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal
    },
    changeData: {
      handler: function(val) {
        this.convertDataToIsoDuration()
      },
      deep: true,
    },
  },
  beforeMount() {
    this.innerValue = this.value
  },
  mounted() {
    this.parseInnerValue()
  },
  updated() {
    this.parseInnerValue()
  },
}
</script>

<style scoped lang="stylus">
label.inputLabel
  padding 15px

.input
  display inline-block
  width 70px
</style>
